import { Component } from 'react';

import { Card } from 'react-bootstrap'
import { externalLinkIcon } from '../../img/font_awesome/font_awesome';
import translations from "../../config/translation/home_translations.json"
import axios from "axios";
import configData from "../../config/config.json";
import { handleError } from '../../redux/actions/commonStuff';
import { LOADING_STATUES } from "../constants/constants";

class Links extends Component {

    state = {
        links: [],
        loadingStatus: ""
    }

    showLoading = () => {
        if (this.state.loadingStatus === "") {
            this.setState({
                loadingStatus: LOADING_STATUES.LOADING
            })
            return true;
        }
        return false;
    }

    hideLoading = () => {
        this.setState({
            loadingStatus: ""
        })
    }

    componentDidMount() {
        this.showLoading();
        axios.get(configData.LANDNOTIFICATION_SERVER_URL + "home/links?language=" + this.props.language, { withCredentials: true })
            .then(
                (response) => {
                    const content = response.data.content;
                    let links = content.paragraphs;
                    if (!links || links.length === 0) {
                        links = []
                    }

                    this.setState({
                        links
                    }, function () {   // callback function after the state is set
                        this.hideLoading();
                    });
                },
                (error) => {
                    handleError(error, this.props.history);
                }
            );
    }

    render() {
        return (
            <Card>
                <Card.Header className='card-header-light'>
                    {externalLinkIcon}&nbsp;&nbsp;{translations[this.props.language].links}
                </Card.Header>
                <Card.Body style={{ color: '#3675A5' }}>
                    <ul className='list-card' style={{ listStyle: 'none', paddingLeft: 0, marginLeft: 20 }}  >
                            {
                                this.state.links.map((link, index) => {
                                     return <li key={index}>{externalLinkIcon}&nbsp; <a target="_blank" rel="noopener noreferrer" href={link.paragraphContent} style={{ color: '#3675A5', fontWeight: 'bold' }}>{link.heading}</a></li>
                                })
                            }
                        </ul>
                </Card.Body>
            </Card>
        )
    }
}

export default Links;
